import React from "react"
import I18n from 'i18n-js';
import '../translations.js';

export class AccountSearchTipsSmall extends React.Component {

  render () {
    return (

      <div className="alert alert-danger">
        <p>{ I18n.t("important_all_caps") }</p>
        <ul>
          <li>{ I18n.t("exhibitor.search_tip_1") }</li>
          <br/>
          <li>{ I18n.t("exhibitor.search_tip_2") }</li>
          <br/>
          <li>{ I18n.t("exhibitor.search_tip_3") }</li>
          <br/>
          <li>{ I18n.t("exhibitor.search_tip_4") }</li>
        </ul>
      </div>
    );
  }
}
